import { Component, HostListener, Input, OnInit } from '@angular/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { BaseButtonSize } from '../../../shared/components/button/base-button.component';
import { BaseRolesService } from '../../../core/services/base-roles.service';
import { BASE_PERMISSIONS } from '../../../core/constants/base-permissions';
import { BASE_ROLES } from '../../../core/constants/base-roles';
import { BaseApplicationSectionsInterface } from '../../../shared/interfaces/base-application-sections.interface';

@Component({
  selector: 'base-sidebar',
  templateUrl: './base-sidebar.component.html',
})
export class BaseSidebarComponent implements OnInit {
  @Input() logo: string;
  @Input() applicationSections: BaseApplicationSectionsInterface[] = [];
  buttonSizes = BaseButtonSize;
  tabs: BaseApplicationSectionsInterface[] = [];
  headerHeight = document.querySelector('base-header')?.getBoundingClientRect().height;
  sidebarScrollHeight = this.headerHeight;
  isSidebarLogoVisible = false;

  constructor(private offcanvasService: NgbOffcanvas, private roleService: BaseRolesService) {}

  @HostListener('window:scroll', ['$event'])
  onScroll() {
    const scrollTop = document.documentElement.scrollTop;
    const headerHeight = this.headerHeight as number;
    if (headerHeight - scrollTop > 20) {
      this.sidebarScrollHeight = headerHeight - scrollTop;
      this.isSidebarLogoVisible = false;
    } else {
      this.sidebarScrollHeight = 20;
      this.isSidebarLogoVisible = true;
    }
  }

  ngOnInit(): void {
    this.tabs = this.applicationSections?.filter((option) => {
      return this.roleService.hasWorkCouncilRole()
        ? option.roleKeys.includes(BASE_ROLES.CUSTOMER_WORK_COUNCIL)
        : !option.featurePermissionKeys.length ||
            option.featurePermissionKeys.some((permission) =>
              this.roleService.hasFeaturePermission(permission as BASE_PERMISSIONS)
            );
    });
  }
}
